import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { PermissionProducts } from "~pages/Users/enums/permissionProducts";
import type { AddUserForm } from "~pages/Users/PermissionUserListPage/types";
import type { UserResponse } from "~types/user";

const useAddPermissionUser = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<UserResponse, Error, AddUserForm>({
    mutationFn: async (userData: AddUserForm) => {
      const { selectedProduct, ...rest } = userData;
      return await request(`${sport}/o/${organizationId}/users`, {
        method: "POST",
        body: {
          ...rest,
          isForTeamManagerProduct: selectedProduct === PermissionProducts.TeamManager,
        },
      });
    },
    onSuccess: async (response: UserResponse) => {
      if (response?.data?.length > 0) {
        await queryClient.invalidateQueries({
          queryKey: ["permission-users", sport, organizationId],
        });
      }
    },
  });
};

export default useAddPermissionUser;
